import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
 import Button from'../ui/Button';
 import Input from'../ui/Input';
 import Icon from'../AppIcon';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const [isLoading, setIsLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  
  const { signIn, authError, clearError } = useAuth()
  const navigate = useNavigate()

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    clearError()
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    
    try {
      const result = await signIn(formData.email, formData.password)
      
      if (result?.success) {
        navigate('/dashboard')
      }
    } catch (error) {
      console.log('Login error:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="w-20 h-20 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center mx-auto mb-6 animate-cosmic-glow">
            <Icon name="Music" size={32} color="white" />
          </div>
          <h2 className="text-3xl font-heading font-bold text-text-primary">
            Welcome Back
          </h2>
          <p className="mt-2 text-sm text-text-secondary">
            Sign in to your cosmic musical journey
          </p>
        </div>

        {/* Form */}
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-text-primary mb-2">
                Email Address
              </label>
              <Input
                id="email"
                name="email"
                type="email"
                required
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                className="w-full"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-text-primary mb-2">
                Password
              </label>
              <div className="relative">
                <Input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  required
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full pr-10"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <Icon 
                    name={showPassword ? 'EyeOff' : 'Eye'} 
                    size={18} 
                    color="rgb(var(--color-text-secondary))" 
                  />
                </button>
              </div>
            </div>
          </div>

          {/* Error Message */}
          {authError && (
            <div className="glass bg-red-500/10 border border-red-500/20 rounded-xl p-4">
              <div className="flex items-center space-x-2">
                <Icon name="AlertCircle" size={18} color="rgb(239 68 68)" />
                <p className="text-sm text-red-400">{authError}</p>
              </div>
            </div>
          )}

          <div className="flex items-center justify-between">
            <div className="text-sm">
              <Link 
                to="/reset-password" 
                className="font-medium text-accent hover:text-accent/80 transition-colors"
              >
                Forgot your password?
              </Link>
            </div>
          </div>

          <Button
            type="submit"
            disabled={isLoading}
            className="w-full"
            size="lg"
          >
            {isLoading ? (
              <div className="flex items-center justify-center space-x-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                <span>Signing in...</span>
              </div>
            ) : (
              'Sign In'
            )}
          </Button>

          <div className="text-center">
            <span className="text-sm text-text-secondary">
              New to AstroTone?{' '}
              <Link 
                to="/signup" 
                className="font-medium text-accent hover:text-accent/80 transition-colors"
              >
                Create an account
              </Link>
            </span>
          </div>
        </form>

        {/* Demo Account Info */}
        <div className="glass bg-accent/10 border border-accent/20 rounded-xl p-4">
          <h3 className="text-sm font-medium text-accent mb-2">Demo Account</h3>
          <p className="text-xs text-text-secondary mb-2">
            Try AstroTone with these demo credentials:
          </p>
          <div className="space-y-1 text-xs font-mono">
            <p>Email: alex@astrotone.com</p>
            <p>Password: password123</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login